import {
  NumberInput as MantineNumberInput,
  NumberInputProps,
} from "@mantine/core"
import { forwardRef, ReactNode } from "react"

import { Label } from "../../../atoms/Label/Label"
import { EqualWidthGrid } from "../../../layout/EqualWidthGrid/EqualWidthGrid"
import { LabelWithTooltip } from "../../../molecules/LabelWithTooltip/LabelWithTooltip"
import { Loader } from "../../../molecules/Loader/Loader"

type Props = {
  label: string | ReactNode
  isLoading?: boolean
  inlineLabel?: boolean
  tooltip?: string
} & NumberInputProps

export const NumberInput = forwardRef<HTMLInputElement, Props>(
  (
    { isLoading = false, inlineLabel = false, label, tooltip, ...props },
    ref
  ) => {
    const input = (
      <MantineNumberInput
        ref={ref}
        label={inlineLabel ? undefined : label}
        rightSection={isLoading ? <Loader size="xs" /> : undefined}
        {...props}
      />
    )

    return inlineLabel ? (
      <EqualWidthGrid>
        {tooltip && typeof label === "string" ? (
          <LabelWithTooltip label={label} hoverHelperText={tooltip} />
        ) : (
          <Label label={label} />
        )}
        {input}
      </EqualWidthGrid>
    ) : (
      input
    )
  }
)

NumberInput.displayName = "NumberInput"
